const monthCycleOptions = Array.from({ length: 12 }, (_, i) => String(i + 1));

const categoryFields = {
    "Books": [
        { key: "name", label: "Name", type: "text" },
        { key: "cost", label: "Cost", type: "number" },
        { key: "dateOfPurchase", label: "Date of Purchase", type: "date" },
    ],
    "Board/Medical Certifications": [
        {
            key: "name",
            label: "Name",
            type: "autocomplete",
            freeSoloAllowed: true,
            options: [
                "ABEM Recertification",
                "ABEM Written Boards",
                "ABEMS Oral Boards",
                "ACNPC-AG",
                "AOBEM Oral Boards",
                "AOBEM Recertification",
                "AOBEM Written Boards",
                "CCRN",
                "CEN",
                "CFRN",
                "Critical Care Recertification",
                "Critical Care Written Boards",
                "CTRN",
                "ENLS",
                "EMS Recertification",
                "EMS Written Boards",
                "FNP-BC",
                "FNP-C",
                "Health Care Administration Recertification",
                "Health Care Administration Written Boards",
                "Hospice and Palliative Recertification",
                "Hospice and Palliative Written Boards",
                "Pain Medicine Recertification",
                "Pain Medicine Written Boards",
                "PANCE",
                "PANRE",
                "PCCN",
                "Pediatric Emergency Medicine Recertification",
                "Pediatric Emergency Medicine Written Boards",
                "Sports Medicine Recertification",
                "Sports Medicine Written Boards",
                "TCRN",
                "Toxicology Recertification",
                "Toxicology Written Boards",
                "Ultrasound Recertification",
                "Ultrasound Written Boards",
                "Undersea and Hyperbaric Medicine Recertification",
                "Undersea and Hyperbaric Medicine Written Boards"
            ]
        },
        { key: "cost", label: "Cost", type: "number" },
        { key: "dateOfPurchase", label: "Date", type: "date" },
    ],
    "Resuscitation Certifications": [
        {
            key: "name",
            label: "Name",
            type: "autocomplete",
            freeSoloAllowed: true,
            options: [
                "Basic Life Support (BLS)",
                "Advanced Cardiovascular Life Support (ACLS)",
                "Pediatric Advanced Life Support (PALS)",
                "Advanced Trauma Life Support (ATLS)",
                "Neonatal Resuscitation Program (NRP)"
            ],
        },
        { key: "cost", label: "Cost", type: "number" },
        { key: "dateOfPurchase", label: "Date of Purchase", type: "date" },
    ],
    "Conferences": [
        { key: "name", label: "Name", type: "text" },
        { key: "registration", label: "Registration", type: "number" },
        { key: "airfare", label: "Airfare", type: "number" },
        { key: "carRental", label: "Car Rental", type: "number" },
        { key: "taxi", label: "Taxi/Rideshare", type: "number" },
        { key: "gas", label: "Gas", type: "number" },
        { key: "hotel", label: "Hotel/Lodging", type: "number" },
        { key: "parking", label: "Parking", type: "number" },
        { key: "tolls", label: "Tolls", type: "number" },
        { key: "meals", label: "Meals", type: "number" },
        { key: "dateOfPurchase", label: "Date of Purchase", type: "date" },
    ],
    "Medical Journals": [
        {
            key: "name",
            label: "Name",
            type: "autocomplete",
            freeSoloAllowed: true,
            options: [
                "Academic Emergency Medicine",
                "Addictive Behaviors",
                "Alcohol",
                "American Journal of Hospice and Palliative Medicine",
                "Annals of Emergency Medicine",
                "Australasian Emergency Care",
                "Aviation, Space, and Environmental Medicine",
                "Chest",
                "Clinical Journal of Sport Medicine",
                "Critical Care Clinics",
                "Critical Care Medicine",
                "Drug and Alcohol Dependence",
                "European Journal of Emergency Medicine",
                "Journal of Critical Care",
                "Journal of Pain and Symptom Management",
                "Journal of Palliative Medicine",
                "Journal of Science and Medicine in Sport",
                "Journal of the American Academy of PAs",
                "Pain",
                "Pain Medicine",
                "Palliative Medicine",
                "Pediatric Emergency Care",
                "Pediatrics",
                "Regional Anesthesia & Pain Medicine",
                "Regulatory Toxicology and Pharmacology",
                "Resuscitation",
                "The American Journal of Emergency Medicine",
                "The American Journal of Sports Medicine",
                "The Journal for Nurse Practitioners",
                "The Journal of Emergency Medicine",
                "The Journal of Pain",
                "Toxicology and Applied Pharmacology",
                "Toxicology Letters",
                "Ultrasound in Medicine & Biology",
                "Ultrasound Quarterly",
                "Undersea & Hyperbaric Medicine Journal"
            ],
        },
        { key: "cost", label: "Cost", type: "number" },
        { key: "dateOfPurchase", label: "Date of Purchase", type: "date" },
    ],
    "Medical License": [
        {
            key: "name",
            label: "Name",
            type: "autocomplete",
            freeSoloAllowed: true,
            options: [
                "Drug Enforcement Administration (DEA) License",
                "Controlled Substance Registration (CSR)",
                "State Prescriptive Authority License",
                "State Medical License"
            ],
        },
        {
            key: "state",
            label: "State",
            type: "autocomplete",
            options: [
                "Alabama",
                "Alaska",
                "Arizona",
                "Arkansas",
                "California",
                "Colorado",
                "Connecticut",
                "Delaware",
                "Florida",
                "Georgia",
                "Hawaii",
                "Idaho",
                "Illinois",
                "Indiana",
                "Iowa",
                "Kansas",
                "Kentucky",
                "Louisiana",
                "Maine",
                "Maryland",
                "Massachusetts",
                "Michigan",
                "Minnesota",
                "Mississippi",
                "Missouri",
                "Montana",
                "Nebraska",
                "Nevada",
                "New Hampshire",
                "New Jersey",
                "New Mexico",
                "New York",
                "North Carolina",
                "North Dakota",
                "Ohio",
                "Oklahoma",
                "Oregon",
                "Pennsylvania",
                "Rhode Island",
                "South Carolina",
                "South Dakota",
                "Tennessee",
                "Texas",
                "Utah",
                "Vermont",
                "Virginia",
                "Washington",
                "West Virginia",
                "Wisconsin",
                "Wyoming"
            ]
        },
        { key: "cost", label: "Cost", type: "number" },
        { key: "dateOfPurchase", label: "Date ", type: "date" },
    ],
    "Medical Society": [
        {
            key: "name",
            label: "Name",
            type: "autocomplete",
            freeSoloAllowed: true,
            options: [
                "American Academy of Clinical Toxicology",
                "American Academy of Emergency Medicine",
                "American Academy of Hospice and Palliative Medicine",
                "American Academy of Pain Medicine",
                "American Academy of Pediatrics - Section on Emergency Medicine",
                "American Academy of Physician Assistants",
                "American Association of Nurse Practitioners",
                "American College of Chest Physicians",
                "American College of Emergency Physicians",
                "American College of Medical Toxicology",
                "American College of Sports Medicine",
                "American Institute of Ultrasound in Medicine",
                "American Medical Association",
                "American Medical Society for Sports Medicine",
                "American Osteopathic Association",
                "Center to Advance Palliative Care",
                "Divers Alert Network",
                "Emergency Medicine Residents' Association",
                "Emergency Nurses Association",
                "National Association of EMS Physicians",
                "National Association of Pediatric Nurse Practitioners",
                "Neurocritical Care Society",
                "Pediatric Academic Societies",
                "Society for Academic Emergency Medicine",
                "Society of Clinical Ultrasound Fellowships",
                "Society of Critical Care Medicine",
                "Society of Emergency Medicine Physician Assistants",
                "Undersea and Hyperbaric Medical Society",
                "Wilderness Medical Society"
            ]
        },
        { key: "cost", label: "Cost", type: "number" },
        { key: "dateOfPurchase", label: "Date of Purchase", type: "date" },
    ],
    "Phone Apps": [
        {
            key: "name",
            label: "Name",
            type: "autocomplete",
            freeSoloAllowed: true,
            options: [
                "5-Minute Emergency Medicine",
                "Bedside EM",
                "Calculate by QxMD",
                "ECG Stampede",
                "EchoTools",
                "Emergency Central",
                "EMRA Antibiotic Guide",
                "EMRA PressorDex",
                "Eolas (WikiEM)",
                "ICU Trials by ClinCalc",
                "KidsDoc",
                "MDCalc",
                "My Call Bag",
                "Nerve Block",
                "Orthobullets",
                "Pacemaker",
                "PalmEM",
                "Pedi STAT",
                "Peds Guide",
                "POC-US",
                "Poisoning and Drug Overdose Info",
                "PulsePoint Respond",
                "QuickEM",
                "Regional Anesthesia Reference",
                "Resus-US",
                "UpToDate",
                "US Handbook",
                "VisualDx"
            ]
        },
        { key: "cost", label: "Cost", type: "number" },
        { key: "dateOfPurchase", label: "Date of Purchase", type: "date" },
    ],
    "Podcasts": [
        {
            key: "name",
            label: "Name",
            type: "autocomplete",
            freeSoloAllowed: true,
            options: [
                "ACEP Frontline",
                "ALiEM",
                "Always on EM",
                "Core EM",
                "Critical Care Perspectives in Emergency Medicine",
                "Don't Forget the Bubbles Podcast",
                "EM Basic",
                "EM Board Bombs",
                "EM Clerkship",
                "EM Over Easy",
                "EM Pulse Podcast",
                "EM Quick Hits",
                "EMCrit",
                "EMOttawa Podcast",
                "EMRAP",
                "EMplify by EB Medicine",
                "Emergency Medical Minute",
                "ERCast",
                "FOAMcast",
                "Internet Book of Critical Care",
                "Pain Talk",
                "Peds EM Podcast",
                "PEM Currents",
                "PEM ED Podcast",
                "Pediatric Emergency Playbook",
                "Resus Tonight",
                "St. Emlyn's",
                "The Resus Room",
                "The Skeptics' Guide to Emergency Medicine",
                "The Tox and the Hound",
                "The Ultrasound Podcast",
                "Ultrasound GEL"
            ]
        },
        { key: "cost", label: "Cost", type: "number" },
        { key: "dateOfPurchase", label: "Date of Purchase", type: "date" },
    ],
    "Medical Equipment": [
        { key: "name", label: "Name", type: "text" },
        { key: "cost", label: "Cost", type: "number" },
        { key: "dateOfPurchase", label: "Date of Purchase", type: "date" },
    ],
    "Medical Clothing": [
        { key: "name", label: "Name", type: "text" },
        { key: "cost", label: "Cost", type: "number" },
        { key: "dateOfPurchase", label: "Date of Purchase", type: "date" },
    ],
    "Cell Phone": [
        { key: "cost", label: "Cost", type: "number" },
        { key: "dateOfPurchase", label: "DatBe of Purchase", type: "date" },
        { key: "recurring", label: "Recurring", type: "checkbox" },
        { key: "recurringCycleMonths", label: "Cycle (months)", type: "select", options: monthCycleOptions },

    ],
    "Internet": [
        { key: "cost", label: "Cost", type: "number" },
        { key: "dateOfPurchase", label: "Date of Purchase", type: "date" },
        { key: "recurring", label: "Recurring", type: "checkbox" },
        { key: "recurringCycleMonths", label: "Cycle (months)", type: "select", options: monthCycleOptions },

    ],
    "Office Equipment": [
        { key: "name", label: "Name", type: "text" },
        { key: "cost", label: "Cost", type: "number" },
        { key: "dateOfPurchase", label: "Date of Purchase", type: "date" },
    ],
    "Workshops & Seminars": [
        { key: "name", label: "Name", type: "text" },
        { key: "cost", label: "Cost", type: "number" },
        { key: "dateOfPurchase", label: "Date of Purchase", type: "date" },
    ],
    "Online Modules/CME Courses": [
        { key: "name", label: "Name", type: "text" },
        { key: "cost", label: "Cost", type: "number" },
        { key: "dateOfPurchase", label: "Date of Purchase", type: "date" },
    ],
    "TSA Precheck": [
        { key: "cost", label: "Cost", type: "number" },
        { key: "dateOfPurchase", label: "Date of Purchase", type: "date" }
    ],
    "Global Entry": [
        { key: "cost", label: "Cost", type: "number" },
        { key: "dateOfPurchase", label: "Date of Purchase", type: "date" },
    ],
};

export default categoryFields;
